var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { live } from 'lit/directives/live.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let SliderComponent = class SliderComponent extends GGOBaseComponent {
    static { this.properties = {
        min: { type: Number },
        max: { type: Number },
        step: { type: Number },
        value: { type: Number },
        color: { type: String },
        index: { type: Number },
    }; }
    static get styles() {
        return [
            ...super.styles,
            css `
        input[type="range"]::-webkit-slider-runnable-track {
          background: #ffffff;
          box-shadow:rgba(0, 0, 0, 0.15) 1px 1px 2px;
        }
      `
        ];
    }
    constructor() {
        super();
        this.min = 0;
        this.step = 1;
        this.max = 100;
        this.value = 0;
    }
    render() {
        this.style.setProperty('--slider-color', this.color ? this.color : '');
        return html `
      <article class="slds-tile slds-tile_board">
        <div class="slds-form-element">
          <label class="slds-form-element__label" for="zone-slider" style="width:100%;"/>
          <div class="slds-form-element__control slds-m-top_small">
            <div class="slds-slider">
              <input
                type="range"
                id="zone-slider"
                class="slds-slider__range"
                min="${this.min}"
                max="${this.max}"
                step="${this.step}"
                .value="${live(this.value)}"
                @input=${this.changeHandler}
              />
            </div>
          </div>
        </div>
      </article>
    `;
    }
    get input() {
        return this.renderRoot?.querySelector('zone-slider') ?? null;
    }
    changeHandler(e) {
        const target = e.target;
        const val = parseInt(target.value);
        this.value = val;
        this.dispatchEvent(new CustomEvent('change', { detail: { id: this.index, value: val }, bubbles: true, composed: true }));
    }
};
SliderComponent = __decorate([
    customElement('ggo-slider')
], SliderComponent);
export { SliderComponent };
